<template>
  <Transition name="slide-left">
    <div v-if="$popup.message" class="tooltip bg-white">
      {{ $popup.message }}
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'Tooltip'
}
</script>